var app = angular.module("leonardo");

var BrowserHistoryService = function($location, $rootScope, $window, $state, $timeout) {
  var service = {
    currentPopup: [],
    popups: {},
    opening: false,
    back: false,
    backPopup: true,
    history: []
  };

  service.init = function() {
    service.currentPopup = [];
    service.history = [];
    service.popups = {};
    service.opening = false;
    service.back = false;
    service.backPopup = true;

    window.addEventListener("popstate",function(event) {
      let hashArray = event.target.location.hash.substring(1).split('#');
      let hash = hashArray[hashArray.length-1];
      if (service.currentPopup.length > 0 && !service.existPopup(hash) &&
        angular.isObject(service.popups[service.currentPopup[service.currentPopup.length-1]])) {
        service.backPopup = false;
        service.popups[service.currentPopup[service.currentPopup.length-1]].closeFn();
      }
    });
  };

  service.register = function(name, closeFn) {
    service.popups[name] = {
      closeFn: closeFn
    };
  };

  service.unregister = function(name) {
    delete this.popups[name];
  };

  service.show = function(name) {
    if (!service.currentPopup.includes(name)) {
      service.opening = true;
      service.currentPopup.push(name);
      var pathArray = $location.$$url.split('#');
      window.history.pushState({ popup: true }, name, "#" + pathArray[0] + "#" + name);
    }
  };

  service.close = function() {
    service.currentPopup.pop();
    if (service.backPopup) {
      window.history.back();
    }
    service.backPopup = true;
  };

  service.existPopup = function(name) {
    var exist = false;
    var length = Object.keys(service.popups).length;
    if (length > 0) {
      exist = Object.keys(service.popups)[length-1] === name;
    }
    return exist;
  };

  $rootScope.$on('$locationChangeSuccess', function() {
    $rootScope.actualLocation = $location.path();
  });

  $rootScope.$watch(function () {return $location.path()}, function (newLocation) {
    //true only for onPopState
    if ($rootScope.actualLocation === newLocation) {
      var back, historyState = $window.history.state;
      back = !(historyState && historyState.position <= $rootScope.stackPosition);
      if (back) {
        service.back = true;
      }
    }
  });

  $rootScope.$watch(function () {return $state.current.name}, function (newState) {
    if (!isNull(newState) && (service.history[service.history.length-1] !== newState)){
      service.history.push(newState);
    }
  });

  service.getBack = function () {
    return service.back;
  };

  service.getBackState = function () {
    return service.history.length > 1 ? service.history.splice(-2)[0] : null;
  };

  return service;
};

app.factory('BrowserHistoryService', ['$location', '$rootScope', '$window', '$state', '$timeout', BrowserHistoryService]);